import type { SoundMap } from './sounds/type';

const soundPathMap: SoundMap = {};

export const registerSounds = (sounds: SoundMap): void => {
    Object.assign(soundPathMap, sounds);
};

export const getSoundPath = (sound: string): string|undefined => (
    soundPathMap[sound]
);
